// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DqSB","largestCol":"styles_largestCol__32yC4","smallestCol":"styles_smallestCol__1J72A"};